import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetDocumentEmailsQuery } from 'src/api/api.generated'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'
import MailLog, { MailLogRow } from 'src/app/pages/common/mail-log/mail-log-drawer'

type DocumentEmailsFormProps = {
  open: boolean
  onClose: () => void
  tenantId: string
  documentId: string
  customerId: string
}

export const DocumentEmailsForm = (props: DocumentEmailsFormProps) => {
  const { open, onClose, tenantId, documentId, customerId } = props
  const { t } = useTranslation()
  const { lg } = useBreakpoints()

  const { data, loading, error } = useGetDocumentEmailsQuery({ variables: { tenantId: tenantId, customerId: customerId, documentId: documentId } })

  const rows: MailLogRow[] = useMemo(() => {
    return (
      data?.getDocumentEmails?.map<MailLogRow>((i) => {
        const lastDate = i.stateTransaction.reduce((a, b) => (a.timestamp > b.timestamp ? a : b))?.timestamp
        const isMailForPaymentRequest = i.documents?.some((d) => d.documentType === 'PAID_IN_FULL')
        return {
          id: i.id,
          description: `${i.subject} ${isMailForPaymentRequest ? ` - (${t('pms.commons.document.with_link')})` : ''}`,
          state: i.emailState,
          timeline: i.stateTransaction,
          receiver: i.to,
          template: i.body,
          date: lastDate,
          type: 'MAIL',
        }
      }) ?? []
    )
  }, [data?.getDocumentEmails])

  return (
    <MailLog
      loading={loading}
      rows={rows}
      title={t('pms.documents.email_log_title')}
      appearance={{ type: 'DRAWER', open: open, onClose: onClose, width: lg ? '70%' : '100%' }}
      toolbar={
        <FormLayoutDefaultToolbar //
          cancelButton={{
            text: t('commons.close'),
            clickHandler: onClose,
          }}
        />
      }
    />
  )
}
